export default {"src":"/_next/static/media/google.db790434.svg","height":24,"width":25};